import axios from "axios";
import { Edit2 } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { Select } from "antd";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "src/components/ui/sheet";
import { Input } from "src/components/ui/input";
import {
  Select as SelectUi,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";

export const TransactionEditSheet = ({
  handleFetchTransactions,
  selectedRecord,
  users,
  loadingUsers,
}) => {
  const [showEditSheet, setShowEditSheet] = useState(false);

  const [editRecord, setEditRecord] = useState({
    user_id: selectedRecord?.user_id || null,
    type: selectedRecord?.type || null,
    amount: selectedRecord?.amount || 0,
    reason: selectedRecord?.reason || "",
  });
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [errors, setErrors] = useState({});

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoadingEdit(true);
    setErrors({});

    try {
      await axios.put(
        `${BaseUrlApi}/transactions/${selectedRecord.bid}`,
        editRecord
      );
      toast("تم التعديل", {
        description: "تم تعديل المعاملة بنجاح 🎉",
      });
      await handleFetchTransactions();
      setShowEditSheet(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
    } finally {
      setLoadingEdit(false);
    }
  };

  return (
    <Sheet open={showEditSheet} onOpenChange={setShowEditSheet}>
      <SheetTrigger asChild>
        <Button
          size="sm"
          className="rounded-lg px-2 text-green-600"
          variant="ghost"
          disabled={loadingUsers}
        >
          <Edit2 />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" dir="rtl">
        <SheetHeader className="text-start">
          <SheetTitle>تعديل المعاملة</SheetTitle>
        </SheetHeader>
        <div className="space-y-4 mt-3">
          {/* User ID */}
          <div className="space-y-2">
            <label className="block font-medium mb-1">اختر عضو</label>
            <Select
              placeholder="اختر عضو"
              value={editRecord.user_id}
              onChange={(e) => setEditRecord({ ...editRecord, user_id: e })}
              style={{ width: "100%" }}
              options={users.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              // These are the key properties to fix touchability in Sheet
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownStyle={{ zIndex: 9999 }}
              virtual={false}
            />
            {errors?.user_id && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.user_id[0]}
              </p>
            )}
          </div>

          {/* Type */}
          <div className="space-y-2">
            <label className="block font-medium">النوع</label>
            <SelectUi
              value={editRecord.type}
              onValueChange={(e) => setEditRecord({ ...editRecord, type: e })}
            >
              <SelectTrigger
                className="rounded-lg"
                aria-label="اختر النوع"
                dir="rtl"
              >
                <SelectValue placeholder="اختر النوع" />
              </SelectTrigger>
              <SelectContent className="rounded-xl">
                <SelectItem value="bonus" className="rounded-lg">
                  Bonus
                </SelectItem>
              </SelectContent>
            </SelectUi>
            {errors?.type && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.type[0]}
              </p>
            )}
          </div>

          {/* Amount */}
          <div className="space-y-2">
            <label className="block font-medium">المبلغ</label>
            <Input
              type="number"
              step="0.01"
              className="w-full p-2 border rounded mt-1"
              value={editRecord.amount}
              onChange={(e) =>
                setEditRecord({
                  ...editRecord,
                  amount: parseFloat(e.target.value),
                })
              }
            />
            {errors?.amount && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.amount[0]}
              </p>
            )}
          </div>

          {/* Reason */}
          <div className="space-y-2">
            <label className="block font-medium">السبب</label>
            <textarea
              className="w-full p-2 border rounded mt-1"
              value={editRecord.reason}
              onChange={(e) =>
                setEditRecord({ ...editRecord, reason: e.target.value })
              }
            />
            {errors?.reason && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.reason[0]}
              </p>
            )}
          </div>

          <div className="text-end">
            <Button onClick={handleEdit} disabled={loadingEdit}>
              {loadingEdit ? "جاري التعديل..." : "تعديل"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
